import Event from '../domain/Event.js';

let MYEFC_AUTH_COOKIE_NAME = 'myEfcCookieAuth';

class LoginHandler {

  constructor(controller, loginValidator, requestBuilder, httpService, trackingService, cookieUtils, utils) {

    this.controller = controller;
    this.loginValidator = loginValidator;
    this.requestBuilder = requestBuilder;
    this.httpService = httpService;
    this.trackingService = trackingService;
    this.cookieUtils = cookieUtils
    this.utils = utils

  }

  handleSubmit(emailAddress, password, rememberMe) {

    this.controller.startActionInProgress();

    this.loginValidator.validate(emailAddress, password);

    let authenticationRequest = this.requestBuilder.getAuthenticationRequest(emailAddress, password, rememberMe);

    return this.httpService.post(authenticationRequest)
      .then((response) => {

        this.cookieUtils.set(MYEFC_AUTH_COOKIE_NAME, response.data.access_token, {secure: true, domain: this.utils.getCookieDomain(), path: '/', expires: response.data.expires_in});
        this.trackingService.submitEvent(Event.LOGIN);
        this.controller.handleSuccess(response.data);

        return response;
      });

  }

}

export default LoginHandler;
